import { createThemeCompiler } from '../../../utils';

export const tagInputThemeCompiler = createThemeCompiler(({ palette, borderRadius, boxShadow, stroke }) => ({
    tagInput: {
        colors: {
            field: {
                default: {
                    backgroundColor: palette.white,
                    borderColor: palette.neutralTertiary,
                    foregroundColor: palette.neutralSecondary
                },
                disabled: {
                    backgroundColor: palette.neutralQuaternary,
                    borderColor: palette.neutralTertiary,
                    foregroundColor: palette.neutralTertiary
                },
                error: {
                    backgroundColor: palette.redPale,
                    borderColor: palette.red,
                    foregroundColor: palette.red
                },
                focussed: {
                    backgroundColor: palette.white,
                    borderColor: palette.themePrimary,
                    foregroundColor: palette.neutralSecondary
                },
                hovered: {
                    backgroundColor: palette.white,
                    borderColor: palette.themePrimary,
                    foregroundColor: palette.neutralSecondary
                }
            },
            tagItem: {
                default: {
                    backgroundColor: palette.white,
                    borderColor: palette.neutralQuaternary,
                    foregroundColor: palette.neutralPrimary,
                    iconColor: palette.themePrimary
                },
                disabled: {
                    backgroundColor: palette.neutralTertiary,
                    borderColor: palette.neutralTertiary,
                    foregroundColor: palette.neutralQuaternary,
                    iconColor: palette.neutralQuaternary
                },
                hovered: {
                    backgroundColor: palette.themePrimary,
                    borderColor: palette.themeDark,
                    foregroundColor: palette.white,
                    iconColor: palette.white
                }
            },
            addButtonColor: palette.neutralTertiary
        },
        composites: {
            field: {
                borderRadius: borderRadius.curvedSmall,
                borderWidth: stroke.thin,
                boxShadow: boxShadow.none
            },
            tagItem: {
                borderRadius: borderRadius.curvedXLarge,
                borderWidth: stroke.thin,
                boxShadow: boxShadow.none
            }
        }
    }
}));
